import PropTypes from 'prop-types';

const SmsEditSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M11.6693 5H28.3359C33.3359 5 36.6693 7.5 36.6693 13.3333V18.5667C36.6693 19.7834 35.4193 20.55 34.3026 20.0667C32.4692 19.2667 30.386 18.9667 28.2026 19.3167C23.836 20.0333 20.2693 23.4833 19.3859 27.8167C19.1359 29.0833 19.1026 30.3167 19.2693 31.5C19.4026 32.4833 18.6026 33.35 17.6193 33.35H11.6693C6.66927 33.35 3.33594 30.85 3.33594 25.0167V13.35C3.33594 7.50002 6.66927 5 11.6693 5Z"
        fill={color}
      />
      <path
        d="M20.0019 19.7833C18.6019 19.7833 17.1852 19.35 16.1019 18.4666L10.8852 14.3C10.3519 13.8666 10.2519 13.0833 10.6852 12.55C11.1186 12.0167 11.9019 11.9167 12.4352 12.35L17.6519 16.5167C18.9186 17.5333 21.0686 17.5333 22.3352 16.5167L27.5519 12.35C28.0852 11.9167 28.8852 12 29.3019 12.55C29.7352 13.0833 29.6519 13.8833 29.1019 14.3L23.8852 18.4666C22.8186 19.35 21.4019 19.7833 20.0019 19.7833Z"
        fill={color}
      />
      <path
        d="M29.9974 21.6667C25.3974 21.6667 21.6641 25.3834 21.6641 30C21.6641 34.6 25.3974 38.3334 29.9974 38.3334C34.6141 38.3334 38.3307 34.6 38.3307 30C38.3307 25.3834 34.6141 21.6667 29.9974 21.6667ZM33.414 29.25L32.7974 29.85L29.1807 33.4833C29.0141 33.6333 28.6974 33.8 28.464 33.8333L26.8307 34.0667C26.2474 34.15 25.8307 33.7334 25.914 33.15L26.1474 31.5167C26.1807 31.2834 26.3307 30.9667 26.4974 30.8L30.1307 27.1833L30.7307 26.5667C31.1307 26.1667 31.5807 25.9 32.0474 25.9C32.4474 25.9 32.8974 26.0834 33.3974 26.5667C34.4974 27.6667 34.1474 28.5167 33.414 29.25Z"
        fill={color}
      />
    </svg>
  );
};

SmsEditSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SmsEditSvg;
